import AXIOS from '@/axios-instance';

export default {
  addCustomModelingElement(elem){
    return AXIOS.post("/customModelingEndpoint", elem);
  },
  getCustomModelingElements() {
    return AXIOS.get("/customModelingEndpoint");
  },
  removeCustomModelingElement(id){
    return AXIOS.delete("customModelingEndpoint/"+id);
  },
/*   getIcon(name){
    return AXIOS.get("https://fonts.gstatic.com/s/i/materialicons/"+name+"/v16/24px.svg");
  },
  loadMaterialIcons(){
    return AXIOS.get("https://fonts.google.com/metadata/icons");
  } */
}